/* global Swiper */
// **********************************************************
// Hero slider
// **********************************************************

const heroSliderElements = document.querySelectorAll('[data-slider="hero-slider"]');
const heroSliderOptions = {
  loop: true,
  autoplay: {
    delay: 3500,
  },
  speed: 1500,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
};

const getSlides = (mainSliderParent) => {
  // Since we are using loop inside Swiper, we have to filter out only the slides that are visible
  return Array.from(mainSliderParent.querySelectorAll('.swiper-slide')).filter((slide) =>
    !slide.classList.contains('swiper-slide-duplicate') && !slide.classList.contains('swiper-slide-duplicate-prev') && !slide.classList.contains('swiper-slide-duplicate-next') && !slide.classList.contains('swiper-slide-duplicate-active')
  );
}

const changeMenuColor = (heroSliderSlide, heroSlider, paginationElement) => {
  const activeSlide = document.querySelector('.swiper-slide.swiper-slide-active');
  const heroSlideClass = activeSlide.classList.contains('swiper-slide--dark');
  paginationElement.classList.toggle('pagination--dark', heroSlideClass);
  const menu = document.querySelector('.header-main');
  menu?.classList.toggle('header-main--dark', heroSlideClass);
}

heroSliderElements.forEach((el) => {
  const mainSliderParent = el.closest('.hero-slider__wrapper');
  const paginationElement = mainSliderParent.querySelector('.swiper-pagination');
  heroSliderOptions.navigation.nextEl = mainSliderParent.querySelector('.arrow-right');
  heroSliderOptions.navigation.prevEl = mainSliderParent.querySelector('.arrow-left');
  heroSliderOptions.pagination.el = mainSliderParent.querySelector('.swiper-pagination');
  const heroSlider = new Swiper(el, heroSliderOptions);

  // Update color on initialization
  changeMenuColor(getSlides(mainSliderParent), heroSlider, paginationElement);

  // Listen for slide change, change color accordingly
  heroSlider.on('slideChangeTransitionStart', () => changeMenuColor(getSlides(mainSliderParent), heroSlider, paginationElement));
});
